import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const AssetAndServiceRepository = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/software/jira/service-management/features/asset-and-configuration-management"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AssetAndServiceRepository.header",
            defaultMessage: "Asset and service repository"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AssetAndServiceRepository.body",
            defaultMessage:
                "Track and manage the ownership and lifecycle of any asset or service for inventory purposes, auditing, and more. Gain visibility into dependencies, quickly troubleshoot incidents, and minimize the risk of changes."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AssetAndServiceRepository.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about assets."
            },

            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default AssetAndServiceRepository;
